import React from 'react';
import { Badge } from '../ui/badge';
import { 
  Shield, 
  Clock, 
  Star, 
  CheckCircle2, 
  Zap, 
  Award,
  BadgeCheck,
  ThumbsUp
} from 'lucide-react';

// Provider verification levels (0-4)
export const VERIFICATION_LEVELS = {
  0: { name: 'New', color: 'bg-gray-100 text-gray-600', icon: null },
  1: { name: 'Verified', color: 'bg-blue-100 text-blue-700', icon: CheckCircle2 },
  2: { name: 'Trusted', color: 'bg-green-100 text-green-700', icon: Shield },
  3: { name: 'Premium', color: 'bg-purple-100 text-purple-700', icon: Award },
  4: { name: 'Elite', color: 'bg-yellow-100 text-yellow-700', icon: BadgeCheck },
};

// Achievement badges
export const ACHIEVEMENT_BADGES = {
  verified_tailor: { name: 'Verified Tailor', icon: CheckCircle2, color: 'text-blue-600' },
  fast_response: { name: 'Fast Response', icon: Zap, color: 'text-yellow-600' },
  top_rated: { name: 'Top Rated', icon: Star, color: 'text-orange-600' },
  quick_delivery: { name: 'Quick Delivery', icon: Clock, color: 'text-green-600' },
  highly_recommended: { name: 'Highly Recommended', icon: ThumbsUp, color: 'text-purple-600' },
  master_craftsman: { name: 'Master Craftsman', icon: Award, color: 'text-amber-600' },
};

// Provider Level Badge
export const ProviderLevelBadge = ({ level = 0, size = 'sm' }) => {
  const levelInfo = VERIFICATION_LEVELS[level] || VERIFICATION_LEVELS[0];
  const Icon = levelInfo.icon;
  
  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
  };
  
  return (
    <Badge className={`${levelInfo.color} ${sizeClasses[size]} flex items-center gap-1`}>
      {Icon && <Icon className="h-3 w-3" />}
      <span>{levelInfo.name}</span>
    </Badge>
  );
};

// Achievement Badge
export const AchievementBadge = ({ badge, size = 'sm' }) => {
  const badgeInfo = ACHIEVEMENT_BADGES[badge];
  if (!badgeInfo) return null;
  
  const Icon = badgeInfo.icon;
  
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
  };
  
  return (
    <div 
      className={`flex items-center gap-1 ${badgeInfo.color}`}
      title={badgeInfo.name}
    >
      <Icon className={sizeClasses[size]} />
    </div>
  );
};

// Provider Badges Row
const ServiceProviderBadges = ({ 
  verificationLevel = 0, 
  achievements = [], 
  showLabel = true,
  maxBadges = 3 
}) => {
  const displayBadges = achievements.slice(0, maxBadges);
  const remainingCount = achievements.length - maxBadges;
  
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <ProviderLevelBadge level={verificationLevel} />
      
      {displayBadges.length > 0 && (
        <div className="flex items-center gap-1">
          {displayBadges.map((badge, index) => (
            <AchievementBadge key={index} badge={badge} />
          ))}
          {remainingCount > 0 && (
            <span className="text-xs text-gray-400">+{remainingCount}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceProviderBadges;
